import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import SEOHead from "@/components/SEOHead";

const Terms = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SEOHead
        title="Vilkår og betingelser | MySabbat"
        description="Læs MySabbats vilkår og betingelser for brug af appen."
        path="/terms"
      />
      <Header />

      {/* Content */}
      <main className="flex-1 py-12 md:py-20">
        <div className="container">
          {/* Back button */}
          <div className="max-w-2xl mx-auto mb-8">
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary/10 text-primary hover:bg-primary/20 transition-colors font-medium text-sm"
            >
              <ChevronLeft className="w-4 h-4" />
              Tilbage til forsiden
            </Link>
          </div>

          <article className="max-w-2xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-semibold text-foreground mb-2">
              Vilkår og betingelser for MySabbat
            </h1>
            <p className="text-muted-foreground mb-10">
              Senest opdateret: {new Date().toLocaleDateString('da-DK', { day: '2-digit', month: '2-digit', year: 'numeric' })}
            </p>

            <div className="bg-card rounded-2xl p-8 md:p-10 shadow-sm border border-border/40 space-y-8">
              {/* Section 1 */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">1. Formål</h2>
                <p className="text-foreground/80 leading-relaxed">
                  MySabbat hjælper dig med at planlægge din næste periode gennem værktøjer, guides og inspiration.
                </p>
              </section>

              {/* Section 2 */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">2. Kontooprettelse</h2>
                <p className="text-foreground/80 leading-relaxed">
                  Du skal være mindst 16 år. Du er ansvarlig for, at dine oplysninger er korrekte, og at din adgangskode holdes sikker.
                </p>
              </section>

              {/* Section 3 */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">3. Ansvarsbegrænsning</h2>
                <p className="text-foreground/80 leading-relaxed">
                  MySabbat kan ikke garantere, at alt indhold er 100% korrekt. Du er selv ansvarlig for dine rejse-, økonomi- og uddannelsesvalg.
                </p>
              </section>

              {/* Section 4 */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">4. Betalinger</h2>
                <p className="text-foreground/80 leading-relaxed">
                  Fremtidige betalingsfunktioner håndteres via App Store eller Google Play.
                </p>
              </section>

              {/* Section 5 */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">5. Opsigelse af konto</h2>
                <p className="text-foreground/80 leading-relaxed">
                  Du kan til enhver tid slette din konto i appen. Data slettes inden for 30 dage.
                </p>
              </section>

              {/* Section 6 */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">6. Kontakt</h2>
                <p className="text-foreground/80 leading-relaxed">
                  <a href="mailto:kontakt@mysabbat.dk" className="text-primary hover:underline">
                    kontakt@mysabbat.dk
                  </a>
                </p>
              </section>
            </div>
          </article>
        </div>
      </main>

      <Footer />
      <CookieConsent />
    </div>
  );
};

export default Terms;
